import { type FC, Fragment } from 'react';
import { SvgIcon } from './svg-icon';
import ClickableIcon from './clickable-icon';
import { extractHourMinute } from '../utils/helpers';
import type { AppointmentSlot } from '../models/repair-bookings';
import styles from '../styles/time-picker.module.scss';

const TimePicker: FC<{
    className?: string;
    day: string;
    slots: AppointmentSlot[];
    onSlotSelect: (slot: AppointmentSlot) => void;
}> = ({ className = '', day, slots, onSlotSelect }) => {
    return (
        <div className={`${styles.timePicker} ${className}`}>
            <div className={styles.dayTitle}>{day}</div>
            <div className={styles.grid}>
                <div className={`${styles.cell} ${styles.headerCell}`}>時間</div>
                <div className={`${styles.cell} ${styles.headerCell}`}>{day}</div>
                {slots.map((slot) => {
                    const label = `${extractHourMinute(slot.start_at)}～`;
                    return (
                        <Fragment key={slot.start_at}>
                            <div className={styles.cell}>{label}</div>
                            <div className={styles.cell}>
                                {slot.appointment_id.length > 0 ? (
                                    <ClickableIcon
                                        iconName="circle"
                                        onClick={() => onSlotSelect(slot)}
                                    />
                                ) : (
                                    <SvgIcon name="cross" />
                                )}
                            </div>
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default TimePicker;
